import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilityService } from '../../../services/utility.service';

@Component({
    selector: 'app-google-default-review',
    imports: [CommonModule],
    templateUrl: './google-default-review.component.html',
    styleUrls: ['./google-default-review.component.scss']
})
export class GoogleDefaultReviewComponent {

  @Input() class: string;
  @Input() isTitleHidden: boolean = false;
  @Input() isTrustpilot: boolean = false;

  constructor(public utilityService: UtilityService) { }
}
